import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

interface TransferListProps {
  itemsDisponiveis: any[];
  itemsSelecionados: any[];
  displayField: string;
  onChange: (selecionados: any[]) => void;
  tituloDisponiveis?: string;
  tituloSelecionados?: string;
  disabled?: boolean;
}

const TransferList: React.FC<TransferListProps> = ({
  itemsDisponiveis,
  itemsSelecionados,
  displayField,
  onChange,
  tituloDisponiveis = 'Disponíveis',
  tituloSelecionados = 'Selecionados',
  disabled = false
}) => {
  const [leftSelection, setLeftSelection] = useState<any[]>([]);
  const [rightSelection, setRightSelection] = useState<any[]>([]);

  useEffect(() => {
    setLeftSelection([]);
    setRightSelection([]);
  }, [itemsDisponiveis.length, itemsSelecionados.length]);

  const handleSelect = (item: any, side: 'left' | 'right') => {
    if (disabled) return;
    const list = side === 'left' ? leftSelection : rightSelection;
    const setList = side === 'left' ? setLeftSelection : setRightSelection;

    if (list.includes(item)) {
      setList(list.filter(i => i !== item));
    } else {
      setList([...list, item]);
    }
  };

  const moveRight = () => {
    onChange([...itemsSelecionados, ...leftSelection]);
    setLeftSelection([]);
  };

  const moveLeft = () => {
    const newSelected = itemsSelecionados.filter(item => !rightSelection.includes(item));
    onChange(newSelected);
    setRightSelection([]);
  };

  return (
    <div className="row align-items-center">
      <div className="col-5">
        <label className="fw-bold mb-1">{tituloDisponiveis}</label>
        <div className="border rounded" style={{ height: '250px', overflowY: 'auto' }}>
          <ul className="list-group list-group-flush">
            {itemsDisponiveis.map((item, idx) => (
              <li 
                key={idx}
                className={`list-group-item list-group-item-action ${leftSelection.includes(item) ? 'active' : ''}`}
                onClick={() => handleSelect(item, 'left')}
                style={{ cursor: disabled ? 'not-allowed' : 'pointer', padding: '0.5rem' }}
              >
                {item[displayField]}
              </li>
            ))}
            {itemsDisponiveis.length === 0 && <li className="list-group-item text-muted">Vazio</li>}
          </ul>
        </div>
      </div>

      <div className="col-2 text-center">
        <div className="d-grid gap-2">
          <Button variant="outline-primary" size="sm" onClick={moveRight} disabled={leftSelection.length === 0 || disabled}>
            <FontAwesomeIcon icon={faChevronRight} />
          </Button>
          <Button variant="outline-secondary" size="sm" onClick={moveLeft} disabled={rightSelection.length === 0 || disabled}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </Button>
        </div>
      </div>

      <div className="col-5">
        <label className="fw-bold mb-1">{tituloSelecionados}</label>
        <div className="border rounded" style={{ height: '250px', overflowY: 'auto' }}>
          <ul className="list-group list-group-flush">
            {itemsSelecionados.map((item, idx) => (
              <li 
                key={idx}
                className={`list-group-item list-group-item-action ${rightSelection.includes(item) ? 'active' : ''}`}
                onClick={() => handleSelect(item, 'right')}
                style={{ cursor: disabled ? 'not-allowed' : 'pointer', padding: '0.5rem' }}
              >
                {item[displayField]}
              </li>
            ))}
            {itemsSelecionados.length === 0 && <li className="list-group-item text-muted">Vazio</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TransferList;